// extracted by mini-css-extract-plugin
module.exports = {"sectionForm":"CompanyData_sectionForm__3e12C","inputLabel":"CompanyData_inputLabel__wxUc_","radioContainer":"CompanyData_radioContainer__3k1Xa"};